export const CODE_SUGGESTIONS = 'code_suggestions' as const;
export const CHAT = 'chat' as const;
// export const WORKFLOW = 'workflow' as const;

export type Feature = typeof CODE_SUGGESTIONS | typeof CHAT; // | typeof WORKFLOW;

export interface UnsupportedGitLabVersionCheckContext {
  version: string;
  baseUrl: string;
}
export const NO_LICENSE = 'code-suggestions-no-license' as const;
export const DUO_DISABLED_FOR_PROJECT = 'duo-disabled-for-project' as const;
export const UNSUPPORTED_GITLAB_VERSION = 'code-suggestions-unsupported-gitlab-version' as const;
export const UNSUPPORTED_LANGUAGE = 'code-suggestions-document-unsupported-language' as const;
export const DISABLED_LANGUAGE = 'code-suggestions-document-disabled-language' as const;
export const SUGGESTIONS_API_ERROR = 'code-suggestions-api-error' as const;

export type StateCheckContextMap = {
  [UNSUPPORTED_GITLAB_VERSION]: UnsupportedGitLabVersionCheckContext;
};

export type StateCheckId =
  | typeof NO_LICENSE
  | typeof DUO_DISABLED_FOR_PROJECT
  | typeof UNSUPPORTED_GITLAB_VERSION
  | typeof UNSUPPORTED_LANGUAGE
  | typeof SUGGESTIONS_API_ERROR
  | typeof DISABLED_LANGUAGE;

export type StateCheckContext<T extends StateCheckId> = T extends keyof StateCheckContextMap
  ? StateCheckContextMap[T]
  : never;

export interface FeatureStateCheck<T extends StateCheckId> {
  checkId: T;
  details?: string;
  context?: StateCheckContext<T>;
}

export interface FeatureState {
  featureId: Feature;
  engagedChecks: FeatureStateCheck<StateCheckId>[];
}

// the first item in the array will have the highest priority
const CODE_SUGGESTIONS_CHECKS_PRIORITY_ORDERED = [
  SUGGESTIONS_API_ERROR,
  UNSUPPORTED_GITLAB_VERSION,
  NO_LICENSE,
  DUO_DISABLED_FOR_PROJECT,
  UNSUPPORTED_LANGUAGE,
  DISABLED_LANGUAGE,
];
const CHAT_CHECKS_PRIORITY_ORDERED = [DUO_DISABLED_FOR_PROJECT];

export const CHECKS_PER_FEATURE: { [key in Feature]: StateCheckId[] } = {
  [CODE_SUGGESTIONS]: CODE_SUGGESTIONS_CHECKS_PRIORITY_ORDERED,
  [CHAT]: CHAT_CHECKS_PRIORITY_ORDERED,
  // [WORKFLOW]: [],
};
